import React, { useMemo } from 'react';
import { RATNA_WARNING_TYPES } from '@/utils/constants/ratna';

import InfoFilledIcon from '@/components/Icons/icons/InfoFilledIcon';

const RatnaWarning = ({ type }: { type: string | null }) => {
  if (!type) return null;

  const {
    iconColor,
    textColor,
    highlightColor,
    borderColor,
    backgroundColor,
    percentage,
    showSuffix = true,
  } = useMemo(() => {
    if (type === RATNA_WARNING_TYPES.TWENTY_FIVE_PERCENT_CONSUMPTION) {
      return {
        iconColor: 'var(--yellow-y-700)',
        textColor: 'var(--yellow-y-700)',
        highlightColor: 'var(--yellow-y-800)',
        borderColor: 'var(--yellow-y-100)',
        backgroundColor: 'var(--yellow-y-50)',
        percentage: 25,
      };
    }

    if (
      type === RATNA_WARNING_TYPES.FIFTY_PERCENT_CONSUMPTION ||
      type === RATNA_WARNING_TYPES.ONE_HUNDRED_PERCENT_CONSUMPTION
    ) {
      return {
        iconColor: 'var(--critical-r-600)',
        textColor: 'var(--critical-r-600)',
        highlightColor: 'var(--critical-r-800)',
        borderColor: 'var(--critical-r-100)',
        backgroundColor: 'var(--critical-r-50)',
        percentage: type === RATNA_WARNING_TYPES.FIFTY_PERCENT_CONSUMPTION ? 50 : 100,
        showSuffix: !(type === RATNA_WARNING_TYPES.ONE_HUNDRED_PERCENT_CONSUMPTION),
      };
    }

    return {
      iconColor: 'var(--yellow-y-700)',
      textColor: 'var(--yellow-y-700)',
      highlightColor: 'var(--yellow-y-800)',
      borderColor: 'var(--yellow-y-100)',
      backgroundColor: 'var(--yellow-y-50)',
      percentage: 25,
    };
  }, [type]);
  return (
    <div
      className="flex items-center gap-1 rounded-lg p-2 h-8"
      style={{ border: `1px solid ${borderColor}`, backgroundColor }}>
      <InfoFilledIcon color={iconColor} />
      <span style={{ color: textColor }} className="text-xs">
        You&apos;ve used{' '}
        <span className="font-medium" style={{ color: highlightColor }}>
          {percentage}%
        </span>{' '}
        of your monthly{' '}
        {showSuffix ? (
          <>
            Ratnas in the{' '}
            <span className="font-medium" style={{ color: highlightColor }}>
              last 24 hours.
            </span>
          </>
        ) : (
          <>Ratna Balance!</>
        )}
      </span>
    </div>
  );
};

export default RatnaWarning;
